import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import BreederProfileLitterCarousel from 'dpl/components/BreederProfile/Show/BreederProfileLitterCarousel';
import BreederProfileLitterList from 'dpl/components/BreederProfile/Show/BreederProfileLitterList';
import BreederProfileCurrentLittersSectionSkeleton from 'dpl/components/BreederProfile/Show/skeletons/BreederProfileCurrentLittersSectionSkeleton';
import { LITTER_STATES } from 'dpl/shared/constants/shared';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { nameUnnamedPuppies } from 'dpl/shared/utils/breeder_app';
import { littersResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

function nameAndSortPuppies(puppies: any[]) {
  return nameUnnamedPuppies(puppies).sort(
    (a: any, b: any) => b.available - a.available
  );
}

export default function BreederProfileCurrentLittersSectionContainer() {
  const { breederProfileId } = useSelector(({ server }: any) => server);

  const {
    isFetching,
    value: { data: litters }
  } = useResourceQuery(
    littersResourceDefinition(breederProfileId, {
      status: LITTER_STATES.BORN,
      exclude_adult: true
    })
  );

  const hasPuppies = useMemo(
    () => litters.some((litter: any) => !isEmpty(litter.puppies)),
    [litters]
  );

  if (isFetching) {
    return <BreederProfileCurrentLittersSectionSkeleton />;
  }

  if (!hasPuppies) {
    return null;
  }

  const Component = IS_LT_MD
    ? BreederProfileLitterList
    : BreederProfileLitterCarousel;

  return (
    <div className="BreederProfileCurrentLittersSectionContainer flex flex-column gap-48 pb12">
      {litters.map((litter: any) => (
        <Component
          key={litter.id}
          breederProfileId={breederProfileId}
          litterName={litter.parent_names}
          puppies={nameAndSortPuppies(litter.puppies)}
          description={litter.age_with_ready_date_description}
        />
      ))}
    </div>
  );
}
